import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { DocenteCard } from "./DocenteCard";
import { paginacion } from "../../utils/paginacion/paginacion";

const DOCENTES_POR_PAGINA = 15;

export const DocenteList = ({ docentes = [], onDelete }) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: docentesEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, docentes, DOCENTES_POR_PAGINA);

  const columnas = [
    "#", "Nombre", "Apellido", "Código",
    "Teléfono", "CI", "Correo", "Género", "Opciones"
  ];

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {docentesEnPagina.map((docente, i) => (
        <DocenteCard
          key={docente?.docente?.idDocente || i}
          docente={docente}
          index={(paginaActual - 1) * DOCENTES_POR_PAGINA + i + 1}
          onDelete={onDelete}
        />
      ))}
    </DataTable>
  );
};
